import React from 'react';

/** Canal d'origine d'un RDV (appointments.source) — demande CODIR 05/10 : « on ne voit pas si
 *  c'est un RDV mail ou LinkedIn ». La colonne est remplie depuis le 08/10 (provenance obligatoire). */
const MAP: Record<string, { icon: string; label: string }> = {
  call: { icon: '☎️', label: 'Cold call' },
  email: { icon: '✉️', label: 'Mailing' },
  linkedin: { icon: '💼', label: 'LinkedIn' },
  entrant: { icon: '📥', label: 'Entrant' },
};
const SourceBadge: React.FC<{ source?: string | null; compact?: boolean }> = ({ source, compact }) => {
  const m = source ? MAP[source] : null;
  if (!m) return null;
  return (
    <span title={`Canal : ${m.label}`} className="inline-flex items-center gap-1 font-mono text-[10px] px-1.5 py-0.5 rounded bg-raise text-dim shrink-0">
      {m.icon}{!compact && <span>{m.label}</span>}
    </span>
  );
};
export default SourceBadge;
